var _rect, _line, _line2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 90,
    viewBox: "0 0 160 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 155,
    height: 85,
    rx: 12.5,
    stroke: "#2d3238",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    x2: 27.5,
    y2: 90,
    stroke: "#2d3238",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 53.5,
    x2: 53.5,
    y2: 90,
    stroke: "#2d3238",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81.5,
    x2: 81.5,
    y2: 90,
    stroke: "#2d3238",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 107.5,
    x2: 107.5,
    y2: 90,
    stroke: "#2d3238",
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 135.5,
    x2: 135.5,
    y2: 90,
    stroke: "#2d3238",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHLayout);
export default __webpack_public_path__ + "static/media/h_layout.48c6d7a0d463ae205d1541bebb839648.svg";
export { ForwardRef as ReactComponent };